// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver,
  listReviver
} = require('client-v2/common/state/record-reviver')

class ArticleProfileCollectionsRecord extends Immutable.Record({
  isCurator: Boolean(), // Implied when smashing together fetched results
  items: Immutable.List(),
  template: String()
}) {
  // No methods
}

ArticleProfileCollectionsRecord.propTypes = {
  isCurator: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  template: PropTypes.string.isRequired
}

ArticleProfileCollectionsRecord.reviver = keyedReviver(ArticleProfileCollectionsRecord, {
  items: listReviver(defaultReviver)
})

module.exports = ArticleProfileCollectionsRecord
